import { render, staticRenderFns } from "./MemberBon.vue?vue&type=template&id=6945ec02&scoped=true"
import script from "./MemberBon.vue?vue&type=script&lang=js"
export * from "./MemberBon.vue?vue&type=script&lang=js"
import style0 from "./MemberBon.vue?vue&type=style&index=0&id=6945ec02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945ec02",
  null
  
)

export default component.exports